"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSupplierById = void 0;
const getSupplierById = async (supabase, id) => {
    const { data, error } = await supabase
        .from("suppliers")
        .select(`*, 
        country:country_id ( id, name, slug )`)
        .eq("id", id)
        .single();
    if (error) {
        throw new Error(error.message);
    }
    return data;
};
exports.getSupplierById = getSupplierById;
